import { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import PhoneInput from "react-phone-input-2";

import { StyledCustomPhoneInput } from "./CustomPhoneInput.styled";


interface CustomPhoneInputProps {
  phone: string;
  setPhone: (arg: string) => void;
  setCountryCode?: (countryCode: string) => void;
  required?: boolean;
  readOnly?: boolean;
  placeholder?: string;
  id?: string;
  setIsError?: (arg: boolean) => void;
  isExistingNumber?: boolean;
}

export const CustomPhoneInput = ({
  id,
  phone,
  setPhone,
  setCountryCode,
  required,
  readOnly,
  setIsError,
  isExistingNumber,
  placeholder = "+225 12 34 567 890",
}: CustomPhoneInputProps) => {
  const { t } = useTranslation();

  const inputWrapperRef = useRef<HTMLDivElement>(null);
  // console.log("phone input id", id);

  useEffect(() => {
    const updateCssVar = () => {
      if (inputWrapperRef.current) {
        const divWidth = inputWrapperRef.current.offsetWidth;
        document.documentElement.style.setProperty(
          "--phone-input-width",
          `${divWidth}px`
        );
      }
    };

    updateCssVar();
    window.addEventListener("resize", updateCssVar);

    return () => {
      window.removeEventListener("resize", updateCssVar);
    };
  }, []);

  return (
    <StyledCustomPhoneInput
      id={id}
      ref={inputWrapperRef}
      className={`${readOnly ? "read-only" : ""} ${phone ? "has-phone" : ""}`}>
      <PhoneInput
        inputProps={{
          id: id ? `${id}-input` : undefined,
          required,
          tabIndex: readOnly ? -1 : 0,
          readOnly,
        }}
        preferredCountries={["ci", "gh"]}
        country={"ci"}
        value={phone}
        onChange={(phoneVal, country: any) => {
          setPhone(phoneVal);
          const selectedCountry = country?.countryCode;
          if (selectedCountry && setCountryCode) {
            setCountryCode(String(selectedCountry).toUpperCase());
          }
        }}
        placeholder={placeholder}
        masks={{ gh: ".. ... ....", ci: ".. .. ... ..." }}
        isValid={(value, country: any) => {
          if (value.match(/\+225/gm) && setIsError) {
            setIsError(false);
            return true;
          } else if (
            setIsError &&
            value.length > 3 &&
            country.countryCode === "225" &&
            !value.match(/^225\s*\d{2}\s*\d{2}\s*\d{2}\s*\d{4}$/)
          ) {
            // todo: Add country code and regex for Ghana and any future countries
            // console.log(country);
            setIsError(true);
            return t("invalid-number");
          } else if (isExistingNumber) {
            if (setIsError) setIsError(true);
            return t("phone-number-exists");
          } else {
            if (setIsError) setIsError(false);
            return true;
          }
        }}
      />
    </StyledCustomPhoneInput>
  );
};
